/**
 * @Description 修改密码弹窗
 */
import { editPasswordModal, handleLogout } from '@/common/api/user';
import V2Form from '@/common/components/Form/V2Form';
import V2FormInputPassword from '@/common/components/Form/V2FormInputPassword/V2FormInputPassword';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { logout } from '@/common/utils/ways';
import { Form, Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
// 8~16位数字或密码组合的密码
const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{8,16}$/;

const EditPasswordModal:FC<any> = ({
  visible,
  setVisible
}) => {
  const [form] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const handleOk = () => {
    form.validateFields().then((res) => {
      if (!passwordRegex.test(res.newPassword)) {
        V2Message.error('请输入8-16位数字或字母组合的密码');
        return;
      }
      if (res.newPassword !== res.rePassword) {
        V2Message.error('两次输入的密码不一致');
        return;
      }
      setConfirmLoading(true);
      // 如果服务端抛错，不关闭弹窗，但是要关闭setConfirmLoading
      editPasswordModal(res)
        .then(() => {
          V2Message.success(`密码修改成功`);
          setVisible(false);
          handleLogout();
          logout();
        })
        .finally(() => {
          setConfirmLoading(false);
        });
    });
  };
  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    visible && form.resetFields();
  }, [visible]);

  return <Modal
    title='修改密码'
    open={visible}
    onOk={handleOk}
    onCancel={handleCancel}
    confirmLoading={confirmLoading}
    destroyOnClose
    centered
  >
    <V2Form
      form={form}
    >
      <V2FormInputPassword
        label='原密码'
        required
        name='oldPassword'
      />
      <V2FormInputPassword
        label='新密码'
        required
        name='newPassword'
        placeholder='设置8-16位数字或字母组合的密码'
      />
      <V2FormInputPassword
        label='确认密码'
        required
        name='rePassword'
        placeholder='请再次输入新密码'
      />
    </V2Form>
  </Modal>;
};
export default EditPasswordModal;
